import React from "react";
import { CustomerData } from "../hooks/useCustomerSearch";
import { useLedger } from "../hooks/useLedger";
import CommonButtons from "../../../../../../shared/components/CommonButtons";
import { ModalWrapper } from "../../../../../../shared/components/ModalWrapper"; // adjust path as needed
import { roundValue } from "../../../../../grocery/hooks/useRound";

interface Props {
  customer: CustomerData;
  onBack: () => void;
  onConfirm: () => void;
  onClose: () => void;
  onAddProduct: () => void;
}

const CustomerLedger: React.FC<Props> = ({ customer, onBack, onConfirm, onClose, onAddProduct }) => {
  const { ledger } = useLedger(customer);

  const rows = [
    { label: "Customer Name", value: ledger?.customer_name || customer.Name },
    { label: "Phone Number", value: customer.phone_number },
    { label: "Outstanding Balance", value: `${roundValue(ledger?.total_outstanding_balance || "0.00")} QAR`, className: "text-red-600 font-bold", },
  ];

  return (
    <ModalWrapper title="Customer Ledger" useTheme={true} onClose={onClose} showBackButton={true} onBack={onBack} width="max-w-xl" className="min-w-[450px] text-center">
      <div className="flex justify-end">
        <CommonButtons label="Add Product" variant="primary" onClick={onAddProduct} className="w-36" />
      </div>
      <div className="p-4 rounded-lg mb-3 justify-center">
        <ul className="space-y-3 text-center">
          {rows.map((row, idx) => (
            <li key={idx} className="flex justify-between min-w-[250px]">
              <span>{row.label}:</span>
              <span className={`text-gray-700 ${row.className || ""}`}>
                {row.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex justify-end gap-4 mt-6">
        <CommonButtons label="Cancel" variant="outlineDanger" onClick={onBack} className="min-w-[130px]" />
        <CommonButtons label="Confirm" onClick={onConfirm} className="min-w-[130px]" />
      </div>
    </ModalWrapper>
  );
};

export default CustomerLedger;
